module.exports = __webpack_public_path__ + "static/media/视见医疗科技有限公司软件使用许可协议.3edbb52c.pdf";